(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["keast-carousel-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.querySelector('[data-keast-carousel-template]');
    if (!template) return;
    const tracks = new Map();
    let nextId = 0;
    const selectors = '.keast-paths__grid, .keast-trust__people-grid, .keast-trust__category-grid';

    const initialize = (root = document) => {
      root.querySelectorAll(selectors).forEach((track) => {
        if (tracks.has(track) || track.children.length < 2) return;
        const controls = template.content.firstElementChild.cloneNode(true);
        const previous = controls.querySelector('[data-keast-previous]');
        const next = controls.querySelector('[data-keast-next]');
        const position = controls.querySelector('[data-keast-position]');
        const controller = new AbortController();
        const heading = track.parentElement.querySelector('h2');
        const originalTabindex = track.getAttribute('tabindex');
        track.id ||= `KeastSwipe-${++nextId}`;
        track.setAttribute('data-keast-swipe-track', '');
        previous.setAttribute('aria-controls', track.id);
        next.setAttribute('aria-controls', track.id);
        if (heading?.textContent.trim()) controls.setAttribute('aria-label', heading.textContent.trim());
        track.after(controls);
        let pendingFrame = 0;

        const update = () => {
          pendingFrame = 0;
          const overflowing = track.scrollWidth > track.clientWidth + 3 && ['auto', 'scroll'].includes(getComputedStyle(track).overflowX);
          controls.hidden = !overflowing;
          if (!overflowing) {
            if (originalTabindex === null) track.removeAttribute('tabindex');
            else track.setAttribute('tabindex', originalTabindex);
            return;
          }
          track.tabIndex = 0;
          const offset = Math.abs(track.scrollLeft);
          const max = track.scrollWidth - track.clientWidth;
          previous.disabled = offset < 3;
          next.disabled = offset > max - 3;
          const bounds = track.getBoundingClientRect();
          const items = [...track.children];
          const visible = items.map((item, index) => {
            const rect = item.getBoundingClientRect();
            const intersection = Math.min(bounds.right, rect.right) - Math.max(bounds.left, rect.left);
            return intersection >= Math.min(rect.width * 0.5, track.clientWidth * 0.5) ? index : -1;
          }).filter((index) => index >= 0);
          const first = (visible[0] ?? 0) + 1;
          const last = (visible.at(-1) ?? 0) + 1;
          const format = first === last ? position.dataset.singleFormat : position.dataset.format;
          const label = format.replace('__FIRST__', first).replace('__LAST__', last).replace('__TOTAL__', items.length);
          if (position.textContent !== label) position.textContent = label;
        };

        const scheduleUpdate = () => {
          if (!pendingFrame) pendingFrame = requestAnimationFrame(update);
        };
        const move = (direction, edge = false) => {
          const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          const style = getComputedStyle(track);
          const step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          if (edge) track.scrollTo({ left: direction < 0 ? 0 : rtl * track.scrollWidth, behavior });
          else track.scrollBy({ left: direction * rtl * step, behavior });
        };
        previous.addEventListener('click', () => move(-1), { signal: controller.signal });
        next.addEventListener('click', () => move(1), { signal: controller.signal });
        track.addEventListener('scroll', scheduleUpdate, { passive: true, signal: controller.signal });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || controls.hidden) return;
          const rtl = getComputedStyle(track).direction === 'rtl';
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            if (event.key === 'Home' || event.key === 'End') move(event.key === 'Home' ? -1 : 1, true);
            else move((event.key === 'ArrowRight') !== rtl ? 1 : -1);
          }
        }, { signal: controller.signal });
        const observer = new ResizeObserver(scheduleUpdate);
        observer.observe(track);
        observer.observe(track.firstElementChild);
        tracks.set(track, () => { controller.abort(); observer.disconnect(); cancelAnimationFrame(pendingFrame); controls.remove(); });
        update();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      for (const [track, dispose] of tracks) {
        if (event.target.contains(track)) { dispose(); tracks.delete(track); }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["keast-parts-library"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root = document) => root.querySelectorAll('[data-parts-library]').forEach((library) => {
    if (library.dataset.ready) return;
    const fallback = library.querySelector('[data-book-fallback]');
    const results = library.querySelector('[data-book-results]');
    const brand = library.querySelector('[data-book-brand]');
    const query = library.querySelector('[data-book-query]');
    const reset = library.querySelector('[data-book-reset]');

    const status = library.querySelector('[data-book-status]');
    const empty = library.querySelector('[data-book-empty]');
    const pages = library.querySelector('[data-book-pages]');
    const previous = library.querySelector('[data-book-previous]');
    const next = library.querySelector('[data-book-next]');
    const compact = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const entries = Array.from(fallback.querySelectorAll('[data-book-entry]'), (element) => ({ element, brand: element.dataset.bookEntry, search: compact(element.textContent) }));
    const initialBrand = library.dataset.initialBrand || '';
    const requestedBrand = new URLSearchParams(window.location.search).get('book_brand') || '';
    const validRequestedBrand = requestedBrand && Array.from(brand.options).some((option) => option.value === requestedBrand);
    if (initialBrand) { brand.value = initialBrand; brand.closest('.keast-books__field').hidden = true; }
    else if (validRequestedBrand) brand.value = requestedBrand;
    let page = 1;
    const pageSize = 6;

    const groupState = new Map();
    let grouped = false;
    const render = (focus = false) => {
      const tokens = (query.value.toLowerCase().normalize('NFKD').match(/[a-z0-9]+/g) || []).map(compact);
      const active = Boolean(brand.value || tokens.length);
      const matches = active ? entries.filter((entry) => (!brand.value || entry.brand === brand.value) && tokens.every((token) => entry.search.includes(token))) : [];
      const groups = Array.from(new Map(matches.filter((entry) => entry.element.dataset.bookKind && entry.element.dataset.bookGroupLabel).map((entry) => [entry.element.dataset.bookKind, {key:entry.element.dataset.bookKind,label:entry.element.dataset.bookGroupLabel}])).values());
      const showGroups = Boolean(brand.value && groups.length > 1 && matches.every((entry) => entry.element.dataset.bookKind && entry.element.dataset.bookGroupLabel));
      const pageCount = showGroups ? 1 : Math.max(1, Math.ceil(matches.length / pageSize));
      page = Math.min(page, pageCount);
      const start = showGroups ? 0 : (page - 1) * pageSize;
      const shown = new Set(showGroups ? matches : matches.slice(start, start + pageSize));
      entries.forEach((entry) => { entry.element.hidden = !shown.has(entry); });
      if (showGroups) {
        const wrappers = groups.flatMap((group) => {
          const members = matches.filter((entry) => entry.element.dataset.bookKind === group.key);
          if (!members.length) return [];
          const wrapper = document.createElement('li');
          wrapper.className = 'keast-books__group';
          const details = document.createElement('details');
          details.dataset.bookGroup = group.key;
          details.open = tokens.length > 0 || groupState.get(brand.value + ':' + group.key) === true;
          const summary = document.createElement('summary');
          summary.append(document.createTextNode(group.label + ' '));
          const count = document.createElement('span');
          count.className = 'keast-books__group-count';
          count.textContent = String(members.length);
          summary.append(count);
          const list = document.createElement('ul');
          list.className = 'keast-books__list';
          list.setAttribute('role', 'list');
          members.forEach((entry) => list.append(entry.element));
          details.append(summary, list);
          details.addEventListener('toggle', () => {
            if (details.isConnected && tokens.length === 0) groupState.set(brand.value + ':' + group.key, details.open);
          });
          wrapper.append(details);
          return [wrapper];
        });
        results.replaceChildren(...wrappers);
        grouped = true;
      } else if (grouped) {
        results.replaceChildren(...entries.map((entry) => entry.element));
        grouped = false;
      }
      results.hidden = !matches.length;

      empty.hidden = !active || Boolean(matches.length);
      status.hidden = !matches.length;
      reset.hidden = !(brand.value !== initialBrand || query.value);
      status.textContent = matches.length ? library.dataset.range.replace('__start__', String(start + 1)).replace('__end__', String(showGroups ? matches.length : Math.min(start + pageSize, matches.length))).replace('__count__', String(matches.length)) : '';
      pages.hidden = showGroups || matches.length <= pageSize;
      previous.disabled = page === 1;
      next.disabled = page === pageCount;
      if (focus) status.focus({ preventScroll: false });
    };
    entries.forEach((entry) => { entry.element.hidden = true; results.append(entry.element); });
    fallback.hidden = true;
    library.querySelector('[data-book-controls]').hidden = false;
    library.dataset.ready = 'true';
    brand.addEventListener('change', () => { page = 1; render(); });
    query.addEventListener('input', () => { page = 1; render(); });
    query.addEventListener('search', () => { page = 1; render(); });
    reset.addEventListener('click', () => { brand.value = initialBrand; query.value = ''; page = 1; render(); (initialBrand ? query : brand).focus(); });
    previous.addEventListener('click', () => { page -= 1; render(true); });
    next.addEventListener('click', () => { page += 1; render(true); });
    const revealLinkedBook = () => {
      const target = entries.find((entry) => entry.element.id === window.location.hash.slice(1));
      if (!target) return;
      brand.value = target.brand;
      query.value = '';
      const brandEntries = entries.filter((entry) => entry.brand === target.brand);
      page = Math.floor(brandEntries.indexOf(target) / pageSize) + 1;
      render();
      const group = target.element.closest('details[data-book-group]');
      if (group) { group.open = true; groupState.set(target.brand + ':' + group.dataset.bookGroup, true); }
      target.element.scrollIntoView({ block: 'start' });
    };
    render();
    revealLinkedBook();
    window.addEventListener('hashchange', revealLinkedBook);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
